import { render } from "./VsDropdown.vue?vue&type=template&id=7da2452e"
import script from "./VsDropdown.vue?vue&type=script&lang=js"
export * from "./VsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__